import { Committee, CommitteeTag } from '../../../types/API'
import { PlatformCommittee } from '../../../types/Committee'

export const CommitteeDisplayOrder: CommitteeTag[] = Object.values(CommitteeTag) as CommitteeTag[]

export const sortByCommitteeDisplayOrder = (a: PlatformCommittee | Committee, b: PlatformCommittee | Committee): number => {
  if (!a || !b) {
    return 0
  }

  const firstTagA: CommitteeTag | undefined = a.tags?.[0] ?? undefined
  const firstTagB: CommitteeTag | undefined = b.tags?.[0] ?? undefined

  if (!firstTagA || !firstTagB) {
    return 0
  }

  const indexA: number = CommitteeDisplayOrder.indexOf(firstTagA)
  const indexB: number = CommitteeDisplayOrder.indexOf(firstTagB)
  if (indexA === -1 && indexB === -1) {
    return 0
  }
  // If either a or b is not found in CommitteeDisplayOrder, move the one that is found to the end
  if (indexA === -1) {
    return 1
  }
  if (indexB === -1) {
    return -1
  }

  return indexA - indexB
}
